"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Avatar = void 0;
const react_1 = __importDefault(require("react"));
require("./Avatar.scss");
const Avatar_scss_json_1 = __importDefault(require("./Avatar.scss.json"));
const package_1 = require("../package");
const Person_1 = require("../shapes/Person");
const Hooks_1 = require("lincd/lib/utils/Hooks");
const helper_1 = require("../utils/helper");
const ImageResize_1 = require("lincd-server-utils/lib/utils/ImageResize");
const LinkedFileStorage_1 = require("lincd/lib/utils/LinkedFileStorage");
const DEFAULT_IMAGE = (0, LinkedFileStorage_1.asset)('/images/no-profile-picture.png');
exports.Avatar = (0, package_1.linkedComponent)(Person_1.Person.request((person) => {
    var _a, _b, _c, _d;
    return ({
        profilePicture: ((_b = (_a = person.profilePicture) === null || _a === void 0 ? void 0 : _a.cropped) === null || _b === void 0 ? void 0 : _b.contentUrl) ||
            ((_d = (_c = person.profilePicture) === null || _c === void 0 ? void 0 : _c.image) === null || _d === void 0 ? void 0 : _d.contentUrl) ||
            DEFAULT_IMAGE,
        givenName: person.givenName,
    });
}), (_a) => {
    var { linkedData, source, size = 'medium', className, fallback, overwriteSource } = _a, restProps = __rest(_a, ["linkedData", "source", "size", "className", "fallback", "overwriteSource"]);
    let { profilePicture, givenName } = linkedData;
    restProps = (0, Hooks_1.useStyles)(restProps, [Avatar_scss_json_1.default.root, Avatar_scss_json_1.default[size], className]);
    let thumbnailSize = size === 'small' ? 64 : size === 'medium' ? 95 : 128;
    let src = overwriteSource || profilePicture;
    if (src && src !== DEFAULT_IMAGE) {
        src = (0, ImageResize_1.getResizedImagePath)((0, helper_1.replaceLocalhostWithSiteRoot)(src), thumbnailSize * 2);
    }
    // android development path fix
    const croppedImageSrc = (0, helper_1.replaceLocalhostWithSiteRoot)(overwriteSource || profilePicture);
    if (src === DEFAULT_IMAGE && fallback) {
        return fallback;
    }
    return (react_1.default.createElement("div", Object.assign({}, restProps),
        react_1.default.createElement("figure", { className: Avatar_scss_json_1.default.wrap },
            react_1.default.createElement("img", { src: src, alt: givenName }))));
});
//register all components in this file
(0, package_1.registerPackageModule)(module);
//# sourceMappingURL=Avatar.js.map